import { Route, Routes } from "react-router-dom";
import { ROUTEPATHS } from "../../libs";
import { ManagePaymentsContainer } from "./manage-payments";
import { ManageAccessTokenContainer } from "./manage-access-token";
import { ReferralProgramsContainer } from "./referrals/ReferralProgramsContainer";
import { CouponCodesContainer } from "./coupons/CouponCodesContainer";
import { MyPlanContainer } from "./my-plan/MyPlanContainer";

export const RouteManagePaymentContainer: React.FC = () => {
  return (
    <Routes>
      <Route path={ROUTEPATHS.MY_PLAN.replace(/^\//, "")} element={<MyPlanContainer />} />
      <Route
        path={ROUTEPATHS.MANAGE_PAYMENTS_PLANS.replace(/^\//, "")}
        element={<ManagePaymentsContainer />}
      />
      <Route
        path={ROUTEPATHS.MANAGE_ACCESS_TOKENS.replace(/^\//, "")}
        element={<ManageAccessTokenContainer />}
      />
      <Route
        path={ROUTEPATHS.MANAGE_REFERRALS.replace(/^\//, "")}
        element={<ReferralProgramsContainer />}
      />
      <Route
        path={ROUTEPATHS.MANAGE_COUPONS.replace(/^\//, "")}
        element={<CouponCodesContainer />}
      />
    </Routes>
  );
};
